/**
 * [API] 자격증 정보
 * @module @apis/certification
 */

import axios from '@/user/apis/common/axios-handle-error.service'
import defailtAxios from '@/user/apis/common/default-axios.service'

/**
 * 월별 시험 정보 조회
 * @method getMonthlyTest
 * @param {number} page
 * @param {number} size
 * @returns {promise} {data} = response or error
 */
const getMonthlyCertificationExam = (yearMonth) => {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/monthly-exams/${yearMonth}`

    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

const getCertificationExamDetails = (examId) => {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/exams/${examId}`

    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

const applyCertificationExam = (examId, body) => {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/exams/${examId}/applicants`

    return defailtAxios
      .post(url, { ...body })
      .then(({ data }) => resolve(data))
      .catch((error) => {
        reject(error)
      })
  })
}

const getCertificationResultByCode = (code) => {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/certifications/${code}`

    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

const getChangableExamByExamId = (examId) => {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/changeable-exams/${examId}`

    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

export const CertificationService = {
  getMonthlyCertificationExam,
  getCertificationExamDetails,
  applyCertificationExam,
  getCertificationResultByCode,
  getChangableExamByExamId,
}
